import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Onboarding from "./views/onboarding/Onboarding";
import Dashboard from "./views/dashboard/Dashboard";
import Login from "./views/login/login";
import Monitoring from "./views/monitoring/monitoring";
import { ThemeProvider } from '@mui/material/styles';
import theme from "../src/components/themes"
import Backoffice from "./views/backoffice/Backoffice"
import TrainingDataManager from "./views/training/TrainingDataManager";
import ProtectedRoute from './components/ProtectedRoute';
import { sessionService } from './service/session.service';
import RaspberryPiAdmin from "./views/backoffice/RaspberryPiAdmin";
import ServerAdmin from "./views/servers/ServerAdmin";
import Landing from "./views/landing/Landing";
import AccountsAdmin from "./views/accounts/AccountsAdmin";
import LicenseAdmin from "./views/backoffice/LicenseAdmin";
import Archive from "./views/archive/Archive";
import './App.css';
import Impressum from './views/legal/Impressum';
import Datenschutz from './views/legal/Datenschutz';
import AGB from './views/legal/AGB';
import TrainingManagementView from './views/backoffice/TrainingManagementView';
import CustomerManagementView from './views/backoffice/CustomerManagementView';
import VideoInspectorView from './views/backoffice/VideoInspektorView';
import VideoUploadTest from './views/backoffice/VideoUploadTest';
// Neue View-Importe
import CamerasView from "./views/cameras/CamerasView";
import SettingsView from "./views/settings/SettingsView";
import AdminCameraRecording from "./views/backoffice/AdminCameraRecording";
import AdminProtectedRoute from './components/AdminProtectedRoute';

const App = () => {
  const [appReady, setAppReady] = useState(false);
  
  useEffect(() => {
    // Bei App-Start nur prüfen, ob wir ein Token haben,
    // aber nicht erneut validieren, da dies bereits in index.tsx geschieht
    const checkSessionState = () => {
      try {
        // Prüfe, ob ein Token im localStorage existiert
        const token = localStorage.getItem('token');
        console.log('[DEBUG] App: Token in localStorage beim Start:', 
          token ? `${token.substring(0, 8)}...` : 'none');
        
        // Markiere die App als bereit
        setAppReady(true);
      } catch (error) {
        console.error('[DEBUG] App: Fehler beim Prüfen des Session-Status', error);
        setAppReady(true); // Trotzdem fortfahren
      }
    };
    
    checkSessionState();
  }, []);

  // Optional Ladeanzeige, während die App initialisiert wird
  if (!appReady) {
    return <div>App wird initialisiert...</div>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        {/* Landingpage und Login/Logout-Routen */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Navigate to="/kameras" replace />} />
        
        {/* Neue Hauptseiten (geschützt) */}
        <Route path="/kameras" element={<ProtectedRoute element={<CamerasView />} />} />
        <Route path="/meldungen" element={<ProtectedRoute element={<Archive />} />} />
        <Route path="/einstellungen" element={<ProtectedRoute element={<SettingsView />} />} />
        
        {/* Bestehende Routen mit Umleitungen für doppelte/alte Pfade */}
        <Route path="/archive" element={<Navigate to="/meldungen" replace />} />
        <Route path="/onboarding" element={<Navigate to="/login" replace />} />
        <Route path="/monitoring" element={<ProtectedRoute element={<Monitoring />} />} />
        <Route path="/backoffice" element={<AdminProtectedRoute element={<Backoffice />} />} />
        <Route path="/training" element={<ProtectedRoute element={<TrainingDataManager />} />} />
        <Route path="/raspberry-pis" element={<AdminProtectedRoute element={<RaspberryPiAdmin />} />} />
        <Route path="/servers" element={<AdminProtectedRoute element={<ServerAdmin />} />} />
        <Route path="/accounts-admin" element={<AdminProtectedRoute element={<AccountsAdmin />} />} />
        <Route path="/camera-training" element={<AdminProtectedRoute element={<AdminCameraRecording />} />} />
        <Route path="/license-admin" element={<AdminProtectedRoute element={<LicenseAdmin />} />} />
        <Route path="/training-management" element={<AdminProtectedRoute element={<TrainingManagementView />} />} />
        <Route path="/customer-management" element={<AdminProtectedRoute element={<CustomerManagementView />} />} />
        <Route path="/video-inspector" element={<AdminProtectedRoute element={<VideoInspectorView />} />} />
        <Route path="/video-upload-test" element={<AdminProtectedRoute element={<VideoUploadTest />} />} />
        
        {/* Rechtliche Seiten */}
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/agb" element={<AGB />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
